import { render } from "./TabView.vue?vue&type=template&id=2d14c3f6"
import script from "./TabView.vue?vue&type=script&setup=true&lang=js"
export * from "./TabView.vue?vue&type=script&setup=true&lang=js"

import "./TabView.vue?vue&type=style&index=0&id=2d14c3f6&lang=css"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/AssetGroups/TabView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d14c3f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d14c3f6', __exports__)) {
    console.log('reload')
    api.reload('2d14c3f6', __exports__)
  }
  
  module.hot.accept("./TabView.vue?vue&type=template&id=2d14c3f6", () => {
    console.log('re-render')
    api.rerender('2d14c3f6', render)
  })

}


export default __exports__